export function buildMenuItems(ctx) {
  return [
                {
                    title: 'Página Principal',
                    active: true,
                    component: 'home-icon',
                    dropdown: false,
                    selected: false,
                    route: 'main_menu_page',
                    sub_items:[]
                },
                {
                    title: 'Zonas/Puertas (Locaciones)',
                    section_title: 'Configuración',
                    header_color: '#12346b',
                    active: true,
                    component: 'location',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear Zona/Puerta',
                            route: 'location_new',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Editar Zona/Puerta (todos)',
                            route: 'location',
                            selected: false,
                            active: true
                        },
                        {
                            id: 3,
                            title: '*Crear apartamento "Pagos" (crear inmueble)',
                            route: 'location',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Roles de usuarios',
                    active: true,
                    component: 'user-roles-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear nuevo rol',
                            route: 'user_create_plan',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Lista de usuarios por rol',
                            route: '',
                            selected: false,
                            active: false
                        },
                        {
                            id: 3,
                            title: 'Editar roles de usuarios',
                            route: 'user_list_plans',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Usuarios',
                    component: 'user-icon',
                    active: true,
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Nuevo Usuario',
                            route: 'new_user',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Importar / actualizar usuarios',
                            route: 'import_users',
                            selected: false,
                            active: true
                        },
                        // {
                        //     id: 2,
                        //     title: 'Importar / actualizar empleados',
                        //     route: 'import_employees',
                        //     selected: false,
                        //     active: ctx.getCompany().has_booking_locations
                        // },
                        {
                            id: 3,
                            title: 'Ver todos',
                            route: 'users',
                            selected: false,
                            active: true
                        },
                        {
                            id: 4,
                            title: 'Ver activos',
                            route: 'users_active',
                            selected: false,
                            active: true
                        },
                        {
                            id: 5,
                            title: 'Editar información de usuario',
                            route: 'edit_user',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Noticias',
                    section_title: 'Servicios a residentes',
                    header_color: '#0D47A1',
                    active: true,
                    component: 'news',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear categoría de noticias',
                            route: 'special_categories',
                            selected: false,
                            active: ctx.getCompany().news.general_news
                        },
                        {
                            id: 2,
                            title: 'Noticias',
                            route: 'news',
                            selected: false,
                            active: ctx.getCompany().news.general_news
                        },
                        {
                            id: 3,
                            title: 'Videos',
                            route: 'news_video',
                            selected: false,
                            active: ctx.getCompany().news.video_news
                        },
                        {
                            id: 4,
                            title: 'Noticias Twit',
                            route: 'news_headline',
                            selected: false,
                            active: ctx.getCompany().news.twits_news
                        },
                        {
                            id: 4,
                            title: 'Lista de noticias públicas',
                            route: 'news_public',
                            selected: false,
                            active: ctx.getCompany().news.general_news
                        },
                        {
                            id: 4,
                            title: 'Lista de noticias inactivas',
                            route: 'news_hidden',
                            selected: false,
                            active: ctx.getCompany().news.general_news
                        },
                        {
                            id: 5,
                            title: 'Crear Banner',
                            route: 'banners_index',
                            selected: false,
                            active: true
                        },
                    ]
                },
                {
                    title: 'Mensajería',
                    active: true,
                    component: 'message-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Notificaciones push',
                            route: 'notification',
                            selected: false,
                            active: ctx.getCompany().notifications.push_notifications
                        },
                        {
                            id: 2,
                            title: 'Emails',
                            route: 'email_historial',
                            selected: false,
                            active: ctx.getCompany().messages.segment_mails
                        },
                        {
                            id: 3,
                            title: 'Whatsapp',
                            route: 'massive_whatsapp',
                            selected: false,
                            active: ctx.getCompany().messages.massive_messages
                        },
                        // {
                        //
                        // TODO: Check if needed
                        //     id: 4,
                        //     title: 'Plantillas',
                        //     route: 'whatsapp_templates',
                        //     selected: false,
                        //     active: ctx.getCompany().notifications.whatsapp_messages
                        // }
                    ]
                },
                {
                    title: 'Pagos',
                    active: ctx.getCompany().payments.admin_payments,
                    component: 'payments-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear apartamento',
                            route: 'location',
                            selected: false,
                            active: ctx.getCompany().payments.admin_payments
                        },
                        {
                            id: 2,
                            title: 'Revisar pagos',
                            route: 'configure_property',
                            selected: false,
                            active: ctx.getCompany().payments.admin_payments
                        },
                        {
                            id: 3,
                            title: 'Método de pago',
                            route: 'payment_methods',
                            selected: false,
                            active: ctx.getCompany().payments.admin_payments
                        },
                        {
                            id: 4,
                            title: 'Estado de Pago',
                            route: 'payments_status',
                            selected: false,
                            active: ctx.getCompany().payments.admin_payments
                        }
                    ]
                },
                {
                    title: 'Encuestas',
                    active: true,
                    component: 'form-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear encuesta',
                            route: 'new_form',
                            selected: false,
                            active: ctx.getCompany().forms.custom_forms
                        },
                        {
                            id: 2,
                            title: 'Resultados de encuestas',
                            route: 'forms_index',
                            selected: false,
                            active: ctx.getCompany().forms.custom_forms
                        }
                    ]
                },
                {
                    title: 'Catálogo Emprendimientos',
                    active: ctx.enabledItem(ctx.getCompany().offers),
                    component: 'offer',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear publicación',
                            route: 'offer_new',
                            selected: false,
                            active: ctx.enabledItem(ctx.getCompany().offers)
                        },
                        {
                            id: 2,
                            title: 'Publicaciones creadas',
                            route: 'offer',
                            selected: false,
                            active: ctx.enabledItem(ctx.getCompany().offers)
                        },
                        {
                            id: 3,
                            title: 'Publicaciones ocultas',
                            route: 'offer_hidden',
                            selected: false,
                            active: ctx.enabledItem(ctx.getCompany().offers)
                        },
                        {
                            id: 3,
                            title: 'Categorías de publicaciones',
                            route: 'category',
                            selected: false,
                            active: ctx.enabledItem(ctx.getCompany().offers)
                        },
                    ]
                },
                {
                    title: 'Fidelización',
                    active: ctx.getCompany().rewards.rewards,
                    component: 'reward',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Importar características',
                            route: 'new_segments_data',
                            selected: false,
                            active: ctx.getCompany().rewards.user_characteristics
                        },
                        {
                            id: 2,
                            title: 'Crear segmento',
                            route: 'condition',
                            selected: false,
                            active: ctx.getCompany().rewards.segments
                        },
                        {
                            id: 3,
                            title: 'Listado',
                            route: 'reward',
                            selected: false,
                            active: ctx.getCompany().rewards.rewards
                        },
                        {
                            id: 4,
                            title: 'Crear beneficio',
                            route: 'offer_new',
                            selected: false,
                            active: ctx.getCompany().rewards.rewards
                        },
                        // {
                        //     id: 5,
                        //     title: 'Geolocalización',
                        //     route: 'users_geolocations',
                        //     selected: false,
                        //     active: ctx.getCompany().rewards.rewards
                        // }
                    ]
                },
                {
                    title: 'Directorio',
                    active: false,
                    component: 'directory-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Comunidad',
                    active: false,
                    component: 'community-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Contactos',
                    active: false,
                    component: 'contact-us-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Paquetería',
                    active: ctx.getCompany().parcels.parcels_delivery,
                    component: 'parcels-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Gestionar paquetes',
                            route: 'parcels_index',
                            selected: false,
                            active: ctx.getCompany().parcels.parcels_delivery
                        }
                    ]
                },
                {
                    title: 'Accesos',
                    section_title: 'Seguridad',
                    header_color: '#1565C0',
                    active: ctx.enabledItem(ctx.getCompany().access),
                    component: 'access',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Mapa de calor',
                            route: 'dashboard_accesses',
                            selected: false,
                            active: ctx.getCompany().access.user_access
                        },
                        {
                            id: 2,
                            title: 'Por locación',
                            route: 'access',
                            selected: false,
                            active: ctx.getCompany().access.user_access
                        },
                        {
                            id: 3,
                            title: 'Crear recepcionista (Counter)',
                            route: 'counter_index',
                            selected: false,
                            active: ctx.getCompany().access.counter
                        },
                        {
                            id: 31,
                            title: 'Logs de acciones de Counter',
                            route: 'counter_logs',
                            selected: false,
                            active: ctx.getCompany().access.counter
                        },
                        {
                            id: 4,
                            title: 'Crear QR - Vigilante virtual',
                            route: 'virtual_guard_qr_generator',
                            selected: false,
                            active: ctx.getCompany().access.virtual_guard
                        },
                        {
                            id: 5,
                            title: 'Imprimir QR',
                            route: 'generate_qr',
                            selected: false,
                            active: ctx.getCompany().access.counter
                        },
                        {
                            id: 6,
                            title: 'Dispositivos de acceso por usuario',
                            route: 'access_devices',
                            selected: false,
                            active: true
                        },
                        {
                            id: 7,
                            title: 'Reestablecer dispositivo',
                            route: 'reset_user_devices',
                            selected: false,
                            active: true
                        },
                        {
                            id: 8,
                            title: 'Invitaciones',
                            route: 'invitations_index',
                            selected: false,
                            active: ctx.getCompany().invitations.admin_invitations
                        }
                    ]
                },
                {
                    title: 'Alertas',
                    active: true,
                    component: 'clientinformation',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Accesos por día',
                            route: 'alerts_index',
                            selected: false,
                            active: ctx.getCompany().access.alerts
                        },
                        {
                            id: 2,
                            title: 'Usuario con múltiples dispositivos',
                            route: 'alerts_device_index',
                            selected: false,
                            active: ctx.getCompany().access.alerts
                        }
                    ]
                },
                {
                    title: 'Reserva de espacios',
                    active: true,
                    component: 'spaces-reservation-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear reserva a un usuario',
                            route: 'booking_index',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Cancelar reserva',
                            route: 'cancel_booking',
                            selected: false,
                            active: true
                        },
                        {
                            id: 3,
                            title: 'Reportes',
                            route: 'reports',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Crear recepcionista',
                            route: 'counter_index',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Alarmas',
                    active: ctx.getCompany().alarms.alarms,
                    component: 'alarm-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Reportes',
                            route: 'AlarmsIndex',
                            selected: false,
                            active: ctx.getCompany().alarms.alarms
                        },

                    ]
                },
                {
                    title: 'Dispositivos',
                    active: ctx.getCompany().access.device_administration,
                    component: 'device-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear dispositivo',
                            route: 'new_device',
                            selected: false,
                            active: ctx.getCompany().access.device_administration
                        },
                        {
                            id: 2,
                            title: 'Listado de dispositivos',
                            route: 'devices',
                            selected: false,
                            active: ctx.getCompany().access.device_administration
                        },

                    ]
                },
                {
                    title: 'Invitaciones Empresariales',
                    active: ctx.getCompany().access.invitation_approved,
                    component: 'business-invitations-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Tipos de Invitaciones',
                            route: 'invitation_types',
                            selected: false,
                            active: ctx.getCompany().access.invitation_approved
                        },
                        {
                            id: 2,
                            title: 'Departamentos validadores',
                            route: 'approval_departments',
                            selected: false,
                            active: ctx.getCompany().access.invitation_approved
                        },
                        {
                            id: 3,
                            title: 'Usuarios validadores',
                            route: 'approved_users',
                            selected: false,
                            active: ctx.getCompany().access.invitation_approved
                        },
                        {
                            id: 4,
                            title: 'Criterios de aprovación',
                            route: 'departments_overiview',
                            selected: false,
                            active: ctx.getCompany().access.invitation_approved,
                        },


                    ]
                },
                {
                    title: 'Calendario de tareas',
                    section_title: 'Sistema de Gestión de Calidad',
                    header_color: '#1976D2',
                    active: ctx.getCompany().sgsst.general,
                    component: 'calendar-icon',
                    dropdown: ctx.getCompany().sgsst.general,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Ver calendario',
                            route: 'work_calendar',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Proveedores',
                    active: ctx.getCompany().sgsst.general,
                    component: 'providers-icon',
                    dropdown: ctx.getCompany().sgsst.general,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear proveedor',
                            route: 'providers',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Funcionarios',
                    active: false,
                    component: 'officials-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Censo',
                    active: false,
                    component: 'census-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Brigadistas',
                    active: false,
                    component: 'brigade-members-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Clasificación de residuos',
                    active: false,
                    component: 'waste-sorting-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Usuarios',
                    section_title: 'Reportes',
                    header_color: '#1E88E5',
                    active: true,
                    component: 'user-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Usuarios registrados',
                            route: 'users',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Dashboard',
                            route: 'users_charts',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Accesos',
                    active: true,
                    component: 'access',
                    dropdown: false,
                    selected: false,
                    route: 'reports',
                    sub_items:[]
                },
                {
                    title: 'Reserva de espacios',
                    active: true,
                    component: 'spaces-reservation-icon',
                    dropdown: false,
                    selected: false,
                    route: 'reports',
                    sub_items:[]
                },
                {
                    title: 'Beneficios',
                    active: false,
                    component: 'offer',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Módulos',
                    section_title: 'Módulo de ayuda',
                    header_color: '#1976D2',
                    active: true,
                    component: 'user-roles-icon',
                    dropdown: false,
                    selected: false,
                    route: 'company_features',
                    sub_items: [],
                },
            ];
}

export function filterMenuForUserType(items, userType) {
  if (userType !== 'Counter') return items
  const paginaPrincipal = items.find(item => item.title === 'Página Principal')
  const usuarios = items.find(item => item.title === 'Usuarios')
  if (!paginaPrincipal || !usuarios) return items
  const counterUserSubItems = usuarios.sub_items.filter(sub => sub.route === 'edit_user')
  return [
    paginaPrincipal,
    {
      ...usuarios,
      section_title: 'Configuración',
      header_color: '#12346b',
      sub_items: counterUserSubItems
    }
  ]
}

export function syncMenuSelection(items, routeName) {
  const toName = routeName ? String(routeName) : ''
  if (!toName) return
  items.forEach((item) => {
    let childSelected = false
    if (item.sub_items && item.sub_items.length) {
      item.sub_items.forEach((subItem) => {
        const match = !!(subItem.route && String(subItem.route) === toName)
        subItem.selected = match
        if (match) childSelected = true
      })
    }
    const selfSelected = !!(item.route && String(item.route) === toName)
    item.selected = childSelected || selfSelected
    if (childSelected) item.expanded = true
  })
}



// WEBPACK FOOTER //
// ./src/components/layout/menuConfig.js